module.exports = __webpack_public_path__ + "img/blue-pill.f47fc465.png";